import React from 'react';
import { Flex } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import InnerNavigationItem from './InnerNavigationItem';
import { NavigationDetails } from './interfaces';

const InnerNavigation: React.FC<{ navDetails: NavigationDetails[] }> = ({
  navDetails,
}) => {
  const { query } = useRouter();
  return (
    <Flex justify="center" mx="15px">
      <Flex
        justify="space-between"
        align="center"
        width="100%"
        maxW="490px"
        direction="row"
        gap={['10px', 0]}
        borderWidth="0.8px"
        borderStyle="solid"
        borderColor="grey.100"
        borderRadius="20px"
      >
        {navDetails?.map((item) => {
          if (!item.slug) return null;
          return (
            <InnerNavigationItem
              key={item?.slug?.current ?? ''}
              navigation={item}
              isSelected={item.slug?.current === query.slug}
            />
          );
        })}
      </Flex>
    </Flex>
  );
};

export default InnerNavigation;
